export default "__VITE_ASSET__cZoAYzZ0__"